import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SnackBarService } from '@app/services/snack-bar.service';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { TagService } from '@services/tag.service';
import { Breadcrumb } from '@app/models/view-models/breadcrumb';
@Component({
  selector: 'app-tags-index',
  templateUrl: './tags-index.component.html',
  styleUrls: ['./tags-index.component.scss']
})
export class TagsIndexComponent extends BaseComponent implements OnInit {
  public dataSource: any;
  public data: any;
  public displayedColumns = ['name', 'article_count', 'document_count', 'actions'];
  public dataLoaded = false;
  public node: Breadcrumb;
  constructor(
    public router: Router,
    public state: State,
    public tagService: TagService,
    public snackbarService: SnackBarService,
    public dialog: MatDialog
  ) {
    super();
    this.setObjects({
      modelService: tagService,
      router,
      state,
      snackbarService,
      dialog
    });
    this.setPageVars({
      listenForIndexUpdate: true
    });
    this.modelServiceGetAll().then(() => (this.dataLoaded = true));
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.nodes = [
      {
        label: 'Articles',
        link: 'articles',
      },
      {
        label: 'Tags',
        link: 'tags',
      }
    ];
  }
}
